import { SetEditStatusForActivityAction } from './typings'

export const setEditStatusForActivityActionCreator = (
  payload: number,
): SetEditStatusForActivityAction => ({
  type: 'activitySummary/setEditStatusForActivity',
  payload,
})
